export const VossPricingScheme = { UnitPricing: 0, TierPricing: 1 } as const;
export type VossPricingScheme = (typeof VossPricingScheme)[keyof typeof VossPricingScheme];

export const VossPricingSchemeText: Record<number, string> = {
    [VossPricingScheme.UnitPricing]: 'vossPricingScheme.unitPricing',
    [VossPricingScheme.TierPricing]: 'vossPricingScheme.tierPricing',
};
